export default "__VITE_ASSET__bf9ec444__"